import { Content, ContentRichTextFields } from '@beat-venues/common-types';

import { BLOCKS, INLINES } from '@contentful/rich-text-types';

export const mockContentRichTextBase: Content<
    'contentRichText',
    ContentRichTextFields
> = {
    sys: {
        id: 'mockContentRichText',
        contentType: {
            sys: {
                id: 'contentRichText',
            },
        },
    },
    fields: {
        content: {
            data: {},
            nodeType: BLOCKS.DOCUMENT,
            content: [],
        },
    },
};

export const mockContentRichTextWithHeadings: Content<
    'contentRichText',
    ContentRichTextFields
> = {
    ...mockContentRichTextBase,
    fields: {
        content: {
            ...mockContentRichTextBase.fields.content,
            content: [
                {
                    nodeType: BLOCKS.HEADING_2,
                    data: {},
                    content: [
                        {
                            nodeType: 'text',
                            value: 'Popartiest Justin Bieber wint grote prijzen bij de Grammy Awards',
                            marks: [],
                            data: {},
                        },
                    ],
                },
                {
                    nodeType: BLOCKS.HEADING_3,
                    data: {},
                    content: [
                        {
                            nodeType: 'text',
                            value: 'Popartiest Justin Bieber wint grote prijzen bij de Grammy Awards',
                            marks: [],
                            data: {},
                        },
                    ],
                },
                {
                    nodeType: BLOCKS.HEADING_4,
                    data: {},
                    content: [
                        {
                            nodeType: 'text',
                            value: 'Popartiest Justin Bieber wint grote prijzen bij de Grammy Awards',
                            marks: [],
                            data: {},
                        },
                    ],
                },
                {
                    nodeType: BLOCKS.HEADING_5,
                    data: {},
                    content: [
                        {
                            nodeType: 'text',
                            value: 'Popartiest Justin Bieber wint grote prijzen bij de Grammy Awards',
                            marks: [],
                            data: {},
                        },
                    ],
                },
                {
                    nodeType: BLOCKS.HEADING_6,
                    data: {},
                    content: [
                        {
                            nodeType: 'text',
                            value: 'Popartiest Justin Bieber wint grote prijzen bij de Grammy Awards',
                            marks: [],
                            data: {},
                        },
                    ],
                },
            ],
        },
    },
};

export const mockContentRichTextWithParagraph: Content<
    'contentRichText',
    ContentRichTextFields
> = {
    ...mockContentRichTextBase,
    fields: {
        content: {
            ...mockContentRichTextBase.fields.content,
            content: [
                {
                    nodeType: BLOCKS.PARAGRAPH,
                    data: {},
                    content: [
                        {
                            nodeType: 'text',
                            value: 'Justin Bieber, een van de grootste namen in de popmuziek, heeft in totaal vier prijzen gewonnen op de Grammy Awards-ceremonie van dit jaar.',
                            marks: [],
                            data: {},
                        },
                    ],
                },
            ],
        },
    },
};

export const mockContentRichTextWithLists: Content<
    'contentRichText',
    ContentRichTextFields
> = {
    ...mockContentRichTextBase,
    fields: {
        content: {
            ...mockContentRichTextBase.fields.content,
            content: [
                {
                    nodeType: BLOCKS.UL_LIST,
                    data: {},
                    content: [
                        {
                            nodeType: BLOCKS.LIST_ITEM,
                            data: {},
                            content: [
                                {
                                    nodeType: BLOCKS.PARAGRAPH,
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'Justice World Tour 20/03',
                                            marks: [],
                                            data: {},
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            nodeType: BLOCKS.LIST_ITEM,
                            data: {},
                            content: [
                                {
                                    nodeType: BLOCKS.PARAGRAPH,
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'Justice World Tour 21/03',
                                            marks: [],
                                            data: {},
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    nodeType: BLOCKS.OL_LIST,
                    data: {},
                    content: [
                        {
                            nodeType: BLOCKS.LIST_ITEM,
                            data: {},
                            content: [
                                {
                                    nodeType: BLOCKS.PARAGRAPH,
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'Justice World Tour 22/03',
                                            marks: [],
                                            data: {},
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            nodeType: BLOCKS.LIST_ITEM,
                            data: {},
                            content: [
                                {
                                    nodeType: BLOCKS.PARAGRAPH,
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'Justice World Tour 23/03',
                                            marks: [],
                                            data: {},
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    },
};

export const mockContentRichTextWithBold: Content<
    'contentRichText',
    ContentRichTextFields
> = {
    ...mockContentRichTextBase,
    fields: {
        content: {
            ...mockContentRichTextBase.fields.content,
            content: [
                {
                    nodeType: BLOCKS.PARAGRAPH,
                    data: {},
                    content: [
                        {
                            nodeType: 'text',
                            value: 'Justin Bieber World Tour',
                            marks: [{ type: 'bold' }],
                            data: {},
                        },
                    ],
                },
            ],
        },
    },
};

export const mockContentRichTextWithItalic: Content<
    'contentRichText',
    ContentRichTextFields
> = {
    ...mockContentRichTextBase,
    fields: {
        content: {
            ...mockContentRichTextBase.fields.content,
            content: [
                {
                    nodeType: BLOCKS.PARAGRAPH,
                    data: {},
                    content: [
                        {
                            nodeType: 'text',
                            value: 'Justin Bieber World Tour',
                            marks: [{ type: 'italic' }],
                            data: {},
                        },
                    ],
                },
            ],
        },
    },
};

export const mockContentRichTextWithHr: Content<
    'contentRichText',
    ContentRichTextFields
> = {
    ...mockContentRichTextBase,
    fields: {
        content: {
            ...mockContentRichTextBase.fields.content,
            content: [{ nodeType: BLOCKS.HR, data: {}, content: [] }],
        },
    },
};

export const mockContentRichTextWithHyperlink: Content<
    'contentRichText',
    ContentRichTextFields
> = {
    ...mockContentRichTextBase,
    fields: {
        content: {
            ...mockContentRichTextBase.fields.content,
            content: [
                {
                    nodeType: BLOCKS.PARAGRAPH,
                    data: {},
                    content: [
                        {
                            nodeType: INLINES.HYPERLINK,
                            data: {
                                uri: 'https://sportpaleis.be/nl/event/justin-bieber-d2addcc9',
                            },
                            content: [
                                {
                                    nodeType: 'text',
                                    value: 'Justin Bieber World Tour',
                                    marks: [],
                                    data: {},
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    },
};

export const mockContentRichTextWithEntryHyperlink: Content<
    'contentRichText',
    ContentRichTextFields
> = {
    ...mockContentRichTextBase,
    fields: {
        content: {
            ...mockContentRichTextBase.fields.content,
            content: [
                {
                    nodeType: BLOCKS.PARAGRAPH,
                    data: {},
                    content: [
                        {
                            nodeType: INLINES.ENTRY_HYPERLINK,
                            data: {
                                target: {
                                    metadata: {
                                        tags: [
                                            {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Tag',
                                                    id: 'capitole-ghent',
                                                },
                                            },
                                            {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Tag',
                                                    id: 'forest-national',
                                                },
                                            },
                                            {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Tag',
                                                    id: 'lotto-arena',
                                                },
                                            },
                                            {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Tag',
                                                    id: 'sportpaleis',
                                                },
                                            },
                                            {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Tag',
                                                    id: 'stadsschouwburg-antwerp',
                                                },
                                            },
                                            {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Tag',
                                                    id: 'trixxo-arena',
                                                },
                                            },
                                            {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Tag',
                                                    id: 'trixxo-theater',
                                                },
                                            },
                                        ],
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: '41ny44uganhz',
                                            },
                                        },
                                        id: '2PHGjSmZziYQcoHY3XMXlN',
                                        type: 'Entry',
                                        createdAt: '2023-02-22T09:31:29.731Z',
                                        updatedAt: '2023-03-15T13:40:23.563Z',
                                        environment: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Environment',
                                            },
                                        },
                                        revision: 8,
                                        contentType: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'ContentType',
                                                id: 'page',
                                            },
                                        },
                                        locale: 'nl',
                                    },
                                    fields: {
                                        name: 'Justin Bieber World Tour',
                                        slug: 'justin-bieber-world-tour',
                                        pageMetadata: {
                                            metadata: { tags: [] },
                                            sys: {
                                                space: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Space',
                                                        id: '41ny44uganhz',
                                                    },
                                                },
                                                id: '1VDQvGkp6XWln6zccRQXiJ',
                                                type: 'Entry',
                                                createdAt:
                                                    '2023-02-22T09:16:48.008Z',
                                                updatedAt:
                                                    '2023-02-22T09:16:48.008Z',
                                                environment: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Environment',
                                                    },
                                                },
                                                revision: 1,
                                                contentType: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'ContentType',
                                                        id: 'metadata',
                                                    },
                                                },
                                                locale: 'nl',
                                            },
                                            fields: { name: 'Site metadata' },
                                        },
                                        pageType: {
                                            metadata: { tags: [] },
                                            sys: {
                                                space: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Space',
                                                        id: '41ny44uganhz',
                                                    },
                                                },
                                                id: '5sQSDxfVY3V6Ff4Hh2eGpZ',
                                                type: 'Entry',
                                                createdAt:
                                                    '2023-03-13T15:28:32.520Z',
                                                updatedAt:
                                                    '2023-03-13T15:28:32.520Z',
                                                environment: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Environment',
                                                    },
                                                },
                                                revision: 1,
                                                contentType: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'ContentType',
                                                        id: 'contentPage',
                                                    },
                                                },
                                                locale: 'nl',
                                            },
                                            fields: {
                                                name: 'Groepen',
                                                content: [
                                                    {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Entry',
                                                            id: '5jUxyDuPVgPAqqs0Sei2Cc',
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        hideInSearch: false,
                                    },
                                },
                            },
                            content: [
                                {
                                    nodeType: 'text',
                                    value: 'Justin Bieber World Tour',
                                    marks: [],
                                    data: {},
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    },
};

export const mockContentRichTextWithFull: Content<
    'contentRichText',
    ContentRichTextFields
> = {
    ...mockContentRichTextBase,
    fields: {
        content: {
            ...mockContentRichTextBase.fields.content,
            content: [
                ...mockContentRichTextWithHeadings.fields.content.content,
                ...mockContentRichTextWithParagraph.fields.content.content,
                ...mockContentRichTextWithLists.fields.content.content,
                ...mockContentRichTextWithBold.fields.content.content,
                ...mockContentRichTextWithItalic.fields.content.content,
                ...mockContentRichTextWithHr.fields.content.content,
                ...mockContentRichTextWithHyperlink.fields.content.content,
                ...mockContentRichTextWithEntryHyperlink.fields.content.content,
            ],
        },
    },
};
